import { render, staticRenderFns } from "./Desk.vue?vue&type=template&id=167a5d9a&"
import script from "./Desk.vue?vue&type=script&lang=js&"
export * from "./Desk.vue?vue&type=script&lang=js&"
import style0 from "./Desk.vue?vue&type=style&index=0&id=167a5d9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports